import React, {PropsWithChildren} from 'react';

import './chip.scss';

interface ChipProps {
    wrapperClassName?: string;
    content: number;
}

function Chip(props: PropsWithChildren<ChipProps>): JSX.Element {
    const {wrapperClassName = '', children, content} = props;

    return (
        <div className={`c-chip ${wrapperClassName}`}>
            {content > 0 && <p className="c-chip__label">{content}</p>}
            {children}
        </div>
    );
}

export default Chip;
